import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-left-bar', 'IconArrowLeftBar', [
  ['path', { d: 'M21 12h-18', key: 'svg-0' }],
  ['path', { d: 'M6 9l-3 3l3 3', key: 'svg-1' }],
  ['path', { d: 'M21 9v6', key: 'svg-2' }],
]);
